import { Icon } from '@src/components/icon/Icon';
import { addRowClasses } from './styles';

export interface AddRowProps {
  label: string;
  onClick: () => void;
  testId: string;
}

/**
 * LF360-1823: the "+ Add rule" / "+ Add branch" action row
 * (Figma node 14328:41284).
 */
export const AddRow = ({ label, onClick, testId }: AddRowProps) => (
  <button
    type="button"
    className={addRowClasses()}
    onClick={onClick}
    data-testid={testId}
  >
    {/* LF360-1823 (#113): Icon за замовчуванням medium = 24px; small = 16px. */}
    <Icon type="plus" size="small" />
    {label}
  </button>
);
